import {isFalse} from "@uw-it-sis/lib-react/lib/Utils";
import parse, { domToReact, attributesToProps } from 'html-react-parser';

/**
 * Restricts input on the entry code field to the maxlength value on the input.
 * @param e The onInput js event
 * @return true if the value length is less then or equal to maxlength, else ignore any attempt to input more then the maxlength
 */
export function onEntryCodeInput(e) {
    let value = e.target.value;
    if ( value.length <= e.target.maxLength ) {
        return true;
    } else {
        e.target.value = value.substring(0, value.length - 1);
    }
}

/**
 * Restricts input on the entry code field to just digits and select/copy/cut/paste/tab/esc actions
 * @param e The js event from keydown
 * @return true if key is allowed, if not, then preventDefault
 */
export function onEntryCodeKeyDown(e) {
    // Is the keydown a copy, cut, paste, or select all action
    let charCode = String.fromCharCode(e.which).toLowerCase();
    let isAllowedAction = ( (e.ctrlKey || e.metaKey) && ['a', 'x', 'c', 'v'].includes(charCode));
    // Is the keydown a digit, backspace, esc, or other ctrl/cmd key
    let isAllowedCode = [0, 8, 9, 17, 27, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 91, 93, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105].includes(e.which);
    // If the keydown is an allowed action or allowed key, continue, if not prevent default
    if ( isAllowedCode || isAllowedAction ) {
        return true;
    } else {
        e.preventDefault();
    }
}

/**
 * Return a set of flags set to true if any activity within the given list has at least one of those flags set.
 *
 * @param activityList list of activities
 * @param activityEnrollRestrictionKey optional alternate key to look within activities to determine
 *                                      the enrollRestriction flag. For example, the data model for schedule builder
 *                                      activities has a slightly different field name than that of plan item data
 * @return {{enrollRestriction: boolean, addCode: boolean}}
 */
export function getSectionLegendFlags(activityList, activityEnrollRestrictionKey) {

    if (activityEnrollRestrictionKey === undefined) {
        activityEnrollRestrictionKey = 'enrollRestriction';
    }

    let legends = {
        enrollRestriction: false,
        addCode: false
    };

    for (let activity of activityList) {
        // if the activity has a state key, check that it is active
        if (!activity.stateKey || activity.stateKey.toLowerCase() === 'active') {

            let activityAddCode = activity.addCodeRequired || activity.independentStudy;

            // check if already true, if a single activity has addCodeRequired or independentStudy, legend show is true
            if (isFalse(legends.addCode)) {
                legends.addCode = activityAddCode;
            }

            // check if already true, the enrollment restriction isn't from an activity add code
            // and the activity has the enroll restriction field set to true, legend show is true
            if (isFalse(legends.enrollRestriction) && isFalse(activityAddCode)) {
                legends.enrollRestriction = activity[activityEnrollRestrictionKey];
            }

        }

        if ( Object.keys(legends).map(key => legends[key]).every(value => value) ) { break; }
    }

    return legends;
}

/**
 * Takes an HTML string and finds any A links and if there is not a target attribute, it will add it so it opens in a new window.
 * @param html - string containing html
 * @returns {JSX.Element|ReturnType<typeof domToReact>}
 */
export function addLinkTargetsToHtmlString(html) {
    const options = {
        replace(domNode) {
            if (domNode.name === 'a' && domNode.attribs) {
                const props = domNode.attribs.hasOwnProperty("target") ? attributesToProps(domNode.attribs) : {...attributesToProps(domNode.attribs), ...{target: "_blank"}};
                return <>&nbsp;<a {...props}>{domToReact(domNode.children)}</a>&nbsp;</>;
            }
        },
    };

    return parse(html, options);
}